<template>
  <div
    class="grid h-full w-full max-w-(--breakpoint-md) grid-cols-3 items-center gap-x-3 rounded md:grid-cols-[auto_15%_15%_18%] md:auto-rows-fr">
    <div class="col-span-3 grid h-fit items-center pb-2 grid-cols-subgrid md:col-span-4">
      <div
        class="rounded-xl relative font-bold rounded py-3 text-center text-white bg-secondary md:col-start-2">
        Free
        <div
          class="absolute bottom-0 translate-y-full left-1/2 h-4 w-2 -translate-x-1/2 rotate-180 transform border-r-4 border-b-4 border-l-4 border-transparent border-b-secondary"></div>
      </div>
      <div class="rounded-xl relative font-bold rounded py-3 text-center text-white bg-primary">
        Annual
        <div
          class="absolute bottom-0 translate-y-full left-1/2 h-4 w-2 -translate-x-1/2 rotate-180 transform border-r-4 border-b-4 border-l-4 border-transparent border-b-primary"></div>
      </div>
      <div class="rounded-xl relative font-bold rounded py-3 text-center text-white bg-blue-1">
        Annual plus +
        <div
          class="absolute bottom-0 translate-y-full left-1/2 h-4 w-2 -translate-x-1/2 rotate-180 transform border-r-4 border-b-4 border-l-4 border-transparent border-b-blue-1"></div>
      </div>
    </div>
    <div
      class="col-span-3 grid rounded-t border border-blue-4b bg-white align-top grid-cols-subgrid otivo-shadow md:col-span-4">
      <div class="py-3 text-center text-secondary md:col-start-2">
        <div class="font-bold">$0</div>
      </div>
      <div class="py-3 text-center text-primary">
        <div>
          <span class="font-bold">$119</span>
          <span class="text-xs"> per year</span>
        </div>
        <div class="text-xs">(Normally $165)</div>
      </div>
      <div class="py-3 text-center text-blue-1">
        <span class="font-bold">$299</span>
        <span class="text-xs"> per year</span>
      </div>
    </div>
    <div
      v-for="({ feature, free, basic, plus }, index) in rows"
      :key="`pricing-table-${index}`"
      :class="{
        'rounded-b border-b': index === rows.length - 1,
      }"
      class="col-span-3 grid h-full items-center max-sm:items-center border-x border-b bg-white py-2 max-sm:py-5 grid-cols-subgrid border-blue-4b otivo-shadow md:col-span-4">
      <div class="max-sm:col-span-full max-sm:pb-3 md:pl-5 max-sm:px-5" v-html="feature"></div>
      <Component
        :is="free"
        :aria-label="free === Check ? 'Available' : 'Not available'"
        class="fill-secondary! size-4 mx-auto" />
      <Component
        :is="basic"
        :aria-label="basic === Check ? 'Available' : 'Not available'"
        class="mx-auto size-4" />
      <Component
        :is="plus"
        :aria-label="plus === Check ? 'Available' : 'Not available'"
        class="fill-blue-1! size-4 mx-auto" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import Check from '@/components/SVGS/BrandIcons/16px/tick.svg'
import Dash from '@/components/SVGS/BrandIcons/16px/minus.svg'

const rows = [
  {
    feature: 'Super investment option advice',
    free: Check,
    basic: Check,
    plus: Check,
  },
  {
    feature: "24/7 access to Otivo's learning hub",
    free: Check,
    basic: Check,
    plus: Check,
  },
  {
    feature: 'Ask Otivo - chat to our AI adviser',
    free: Check,
    basic: Check,
    plus: Check,
  },
  {
    feature: 'Life plan and Wealth health checker',
    free: Dash,
    basic: Check,
    plus: Check,
  },
  {
    feature: 'Super contributions and salary sacrifice advice',
    free: Dash,
    basic: Check,
    plus: Check,
  },
  {
    feature: 'Personal insurance advice',
    free: Dash,
    basic: Check,
    plus: Check,
  },
  {
    feature: 'Debt management advice',
    free: Dash,
    basic: Check,
    plus: Check,
  },
  {
    feature: 'Retirement planning advice',
    free: Dash,
    basic: Check,
    plus: Check,
  },
  {
    feature: 'One phone call with Otivo support team',
    free: Dash,
    basic: Dash,
    plus: Check,
  },
]
</script>
